/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
/**
 * NOTE: using traditional object notation with prototype is not possible, because interceptors are not managed as
 * object instances, simply as standalone function containers. They are not considered
 * as stateful objects (at least the call of their functions is made in a procedural way, no scoping).
 */
/** @ngInject */
function XsrfInterceptorFactory($cookies, $log, configuration) {
    const interceptor = {};

    /**
     * Gets the CSRF cookie and insert the CSRF token as a HTTP header.
     *
     * @param {Object} config HTTP request configuration.
     * @return {Object} The same configuration.
     */
    interceptor.request = function(config) {
        const token = $cookies.get(configuration.CSRF_COOKIE_NAME);
        if (token) {
            config.headers['X-XSRF-TOKEN'] = token;
        }

        return config;
    };

    $log.debug('Factory \'XsrfInterceptor\' loaded');
    return interceptor;
}

export { XsrfInterceptorFactory };



// WEBPACK FOOTER //
// ./src/main/front/scripts/util/XsrfInterceptor.js